// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"5513":"fea842f4","7471":"577931aa","8049":"ad1d9c9d"}[chunkId] + ".chunk.css");